import { render, staticRenderFns } from "./DataCombobox.vue?vue&type=template&id=18e3acb8"
import script from "./DataCombobox.vue?vue&type=script&lang=js"
export * from "./DataCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports